import React, { KeyboardEvent, useEffect, useRef, useState } from 'react'

import * as S from './styles'
import { TInputToken } from './types'

export const InputToken = ({ size, value, error, onChange }: TInputToken) => {
  const refInput = useRef<HTMLInputElement>(null)
  const [cursorPosition, setCursorPosition] = useState(-1)

  useEffect(() => {
    refInput.current?.setSelectionRange(cursorPosition + 1, cursorPosition + 1)
  }, [cursorPosition])

  const focusPosition = (pos: number) => {
    refInput.current?.focus()
    refInput.current?.setSelectionRange(pos + 1, pos + 1)
    setCursorPosition(pos)
  }

  const isFocused = (pos: number, isPlaceHolder: boolean) =>
    refInput.current === document.activeElement &&
    cursorPosition !== -1 &&
    ((refInput.current?.selectionStart === size && pos === size - 1) ||
      (isPlaceHolder && refInput.current?.selectionStart === pos) ||
      (!isPlaceHolder && refInput.current?.selectionStart === pos + 1 && value.length - 1 > pos))

  return (
    <S.Container>
      <S.InputStyled>
        {Array.from(Array(size).keys()).map((key, index) => (
          <S.InputStyledContent
            onClick={() => focusPosition(index)}
            isFocused={isFocused(index, value[index] === undefined)}
            isPlaceHolder={value[index] === undefined}
            hasError={!!error}
            key={key}
          >
            {value[index] || 0}
          </S.InputStyledContent>
        ))}
      </S.InputStyled>

      {error && <S.InfoError variant="body-3">Código de verificação inválido</S.InfoError>}

      <S.InputHidden
        id="token"
        type="text"
        maxLength={size}
        value={value}
        inputMode="text"
        onChange={onChange}
        onBlur={() => setCursorPosition(-1)}
        onKeyUp={(e: KeyboardEvent) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            const pos =
              refInput.current?.selectionStart !== 0 ? refInput.current?.selectionStart || size : 1
            focusPosition(pos - 1)
          }
        }}
        autocomplete="one-time-code"
        ref={refInput}
      />
    </S.Container>
  )
}
